import { PlanItem } from "../../plan.model";
import { Tooth } from "../../../../odontogram/odontogram.model";
import { AbstractTreatment } from "../treatment";
import { TreatmentPriceConfiguration } from "../../../../price/price.model";

export class CosmeticOrthodontics extends AbstractTreatment {
  static validate(
    item: PlanItem,
    odontogram: Tooth[],
    items: PlanItem[],
  ): boolean {
    return true;
  }

  static apply(odontogram: Tooth[], item: PlanItem): Tooth[] {
    // TODO
    return odontogram;
  }

  static getPriceConfiguration(): TreatmentPriceConfiguration {
    return {
      type: "simple",
      single: true,
      identifier: this.getIdentifier(),
    };
  }

  static getIdentifier(): string {
    return "cosmetic-orthodontics";
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/plan/treatments/ortho/cosmetic-orthodontics.ts